module.exports = __webpack_public_path__ + "img/before.61f77d91.jpg";